import './scss/browse.scss';
import browse from './js/page/browse';
import localSwingers from './js/page/local-swingers';

export default {
    browse,
    'local-swingers-county': localSwingers,
    'local-swingers-city': localSwingers,
    'local-swingers-top-location-members': localSwingers,
    'local-swingers-city-view-post': localSwingers,
};
